import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ContainerProgressCircle } from "components/waste-icons/svgs/ContainerProgressCircle";
import { useState, useEffect } from "react";
import LineEChartMultiple from "../components/waste/LineEChartMultiple";
import useCustomTranslation from "core/customTranslation";
import { translations } from "../container/translations";

const AssetsList = ({ items, measures, chartRefs }) => {
    const { t: _Tc } = useTranslation("choices");
    const { t: _Tg } = useTranslation("grafics");
    const { t: _tC } = useCustomTranslation(translations);
    const [activeTab, setActiveTab] = useState(null);
    const [containerInfo, setContainerInfo] = useState({});

    // Create ref objects before rendering
    useEffect(() => {
        if (items && items.length > 0) {
            const containerInfo = {};
            items.forEach((item) => {
                if (item.uuids) {
                    item.uuids.forEach((uuid) => {
                        containerInfo[uuid] = {
                            type: item.waste_type,
                            filling: item.filling,
                        };

                        // Initialize refs for this UUID if not already done
                        if (!chartRefs.current[uuid]) {
                            chartRefs.current[uuid] = {
                                filling: null,
                                battery: null,
                                temperature: null,
                            };
                        }
                    });
                }
                setContainerInfo(containerInfo);
            });

            const uuids = Object.keys(containerInfo);
            if (uuids.length > 0 && !activeTab) {
                setActiveTab(uuids[0]);
            }
        }
    }, [items, activeTab]);

    return (
        <>
            {Object.keys(containerInfo).length === 0 ? (
                <div className="text-center mt-5">
                    <h5>No hay dispositivos disponibles</h5>
                </div>
            ) : (
                <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => setActiveTab(k)}
                    className="mb-3">
                    {Object.keys(containerInfo)
                        .filter((uuid) => uuid !== "null")
                        .map((uuid) => {
                            const info = containerInfo[uuid];
                            if (!info || info.filling === null || info.type === null) {
                                return null;
                            }

                            return (
                                <Tab
                                    eventKey={uuid}
                                    title={
                                        <div className="row">
                                            <div
                                                className="col-4"
                                                style={{
                                                    transform: "scale(0.7)",
                                                }}>
                                                <ContainerProgressCircle
                                                    type={info.type}
                                                    percent={info.filling}
                                                />
                                            </div>
                                            <div className="col-8 d-flex align-items-center">
                                                <h6>{uuid}</h6>
                                            </div>
                                        </div>
                                    }
                                    key={uuid}>
                                    <div className="row">
                                        <div className="col-12 d-flex justify-content-between align-items-center"></div>
                                        <div className="col-12">
                                            {uuid in measures ? (
                                                <div className="row">
                                                    {measures[uuid].filling &&
                                                        measures[uuid].filling.length >
                                                        0 ? (
                                                        <div className="col-12 mb-5 chart-limited">
                                                            <h5 className="mb-3">
                                                                UUID: {uuid}
                                                            </h5>
                                                            <div className="chart-container">
                                                                <LineEChartMultiple
                                                                    measuresData={{
                                                                        filling:
                                                                            measures[
                                                                                uuid
                                                                            ].filling,
                                                                    }}
                                                                    translations={{
                                                                        filling: _Tg(
                                                                            "headers.containers.filling"
                                                                        ),
                                                                    }}
                                                                    alerts={
                                                                        measures[uuid]
                                                                            .alerts ||
                                                                        {}
                                                                    }
                                                                    chartRef={(ref) =>
                                                                    (chartRefs.current[
                                                                        uuid
                                                                    ].filling = ref)
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <div className="alert alert-secondary mt-2">
                                                                {_tC("no.measures")}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {measures[uuid].battery_one &&
                                                        measures[uuid].battery_one.length >
                                                        0 ? (
                                                        <div className="col-12">
                                                            <hr className="mb-3" />
                                                            <h5 className="mb-3">
                                                                UUID: {uuid}
                                                            </h5>
                                                            <div className="col-12 chart-limited">
                                                                <LineEChartMultiple
                                                                    measuresData={{
                                                                        battery_one:
                                                                            measures[
                                                                                uuid
                                                                            ]
                                                                                .battery_one ||
                                                                            [],
                                                                    }}
                                                                    chartRef={(ref) =>
                                                                    (chartRefs.current[
                                                                        uuid
                                                                    ].battery = ref)
                                                                    }
                                                                    translations={{
                                                                        battery_one:
                                                                            _Tg(
                                                                                "headers.containers.battery_one"
                                                                            ),
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <hr className="mb-3" />
                                                            <h5 className="mb-3">
                                                                UUID: {uuid}
                                                            </h5>
                                                            <div className="alert alert-secondary mt-2">
                                                                {_tC("no.battery")}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {measures[uuid].temperature &&
                                                        measures[uuid].temperature.length >
                                                        0 ? (
                                                        <div className="col-12">
                                                            <hr className="mb-3" />
                                                            <h5 className="mb-3">
                                                                UUID: {uuid}
                                                            </h5>
                                                            <div className="col-12 chart-limited">
                                                                <LineEChartMultiple
                                                                    measuresData={{
                                                                        temperature:
                                                                            measures[
                                                                                uuid
                                                                            ]
                                                                                .temperature ||
                                                                            [],
                                                                    }}
                                                                    translations={{
                                                                        temperature:
                                                                            _Tg(
                                                                                "headers.containers.temperature"
                                                                            ),
                                                                    }}
                                                                    chartRef={(ref) =>
                                                                    (chartRefs.current[
                                                                        uuid
                                                                    ].temperature =
                                                                        ref)
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <hr className="mb-3" />
                                                            <h5 className="mb-3">
                                                                UUID: {uuid}
                                                            </h5>
                                                            <div className="alert alert-secondary mt-2">
                                                                {_tC("no.temperature")}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="alert alert-secondary mt-2">
                                                    {_tC("no.devices")}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Tab>
                            );
                        })}
                </Tabs>
            )}
        </>
    );
};

export default AssetsList;
